var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncrementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52382 15.3296V9.3052H0.504933C0.302652 9.3052 0.138672 9.14122 0.138672 8.93894V7.176C0.138672 6.97372 0.302652 6.80974 0.504933 6.80974H6.52382V0.766435C6.52382 0.57528 6.67878 0.420319 6.86994 0.420319H8.67865C8.77039 0.420318 8.85837 0.456804 8.92318 0.521731C8.98799 0.586658 9.02432 0.674696 9.02416 0.766435V6.80974H15.0363C15.2437 6.80974 15.4117 6.97782 15.4117 7.18516V8.93466C15.4119 9.03434 15.3724 9.12998 15.302 9.20052C15.2316 9.27105 15.136 9.31069 15.0363 9.31069H9.02416V15.3351C9.02416 15.5353 8.86182 15.6977 8.66156 15.6977H6.88642C6.78929 15.6977 6.69622 15.6587 6.62806 15.5895C6.5599 15.5203 6.52235 15.4267 6.52382 15.3296Z",
    fill: "#003A4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrementIcon);
export default __webpack_public_path__ + "static/media/increment-icon.3c9ed1c9e11131f12a260c930a52be0c.svg";
export { ForwardRef as ReactComponent };